
<script>
import Collapsable from "@/components/Collapsable";

export default {
  components: {
    Collapsable,
  },
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
    },
  },
};
</script>

<template>
  <div class="mb-3">
    <div
      class="p-4 uppercase text-airbnbRed text-lg font-semibold bg-gray-100 border border-solid border-gray-400 rounded-t cursor-pointer select-none"
      data-cy="pageTitle" @click="toggleExpand">
      {{ page.title }}
      <font-awesome-icon :class="{ 'rotate-180': expanded, 'rotate-0': !expanded }" icon="angle-down"
        class="inline-block float-right text-lg" />
    </div>
    <Collapsable ref="boxContent" v-model="expanded"
      class="p-0 h-0 border-l border-r border-b border-solid border-gray-400 leading-snug">
      <!-- eslint-disable vue/no-v-html -->
      <p data-cy="pageContent" class="faqContent p-4 text-s text-lightGrey" v-html="page.content" />
    </Collapsable>
  </div>
</template>


<style>
.rotate-0 {
  transform: rotate(0);
  transition: transform 300ms;
}

.rotate-180 {
  transform: rotate(180deg);
  transition: transform 300ms;
}

.faqContent h2 {
  font-size: 1.5rem;
  font-weight: bolder;
  line-height: 2;
}

.faqContent h3 {
  font-size: 1.3rem;
  font-weight: bold;
  line-height: 1.75;
}

.faqContent h4 {
  font-size: 1.1rem;
  font-weight: bold;
}

.faqContent ul,
.faqContent ol {
  margin-left: 1em;
}

.faqContent ul {
  list-style: disc;
}

.faqContent ol {
  list-style: numeric;
}
</style>
